import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shankesh/webdesign/prateekshawebdesign.com/next.js/src/app/(blog)/category/[slug]/CategoryBlog.js");
